module.exports = __webpack_public_path__ + "img/226.215503cb.jpg";